import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import "../Styles/Itinerary.css"
import pdfhomeimg from "../Images/pdfhomeimg.png"
import logo from "../Images/Jayraj_logo.png"
import packageImgpdf from "../Images/illustrationimg.png"
import hotelImg from "../Images/hotelimg.jpg"
import vahicle from "../Images/quationsimg.png"
import { FaWhatsapp, FaInstagram, FaYoutube, FaFacebook } from 'react-icons/fa'
import api from "../Api.js"
import sanitizeHtml from "sanitize-html";
import { useNavigate } from 'react-router-dom'


function formatDate(dateString) {
    const date = new Date(dateString);

    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Get parts
    const dayName = days[date.getDay()];
    const day = date.getDate();
    const monthName = months[date.getMonth()];

    // Add ordinal suffix
    const getOrdinal = (n) => {
        if (n % 10 === 1 && n % 100 !== 11) return n + "st";
        if (n % 10 === 2 && n % 100 !== 12) return n + "nd";
        if (n % 10 === 3 && n % 100 !== 13) return n + "rd";
        return n + "th";
    };

    return `${dayName} ${getOrdinal(day)} ${monthName}`;
}

function calculateNights(checkIn, checkOut) {
    const inDate = new Date(checkIn);
    const outDate = new Date(checkOut);
    if (isNaN(inDate) || isNaN(outDate)) return 0;

    // Difference in milliseconds
    const diffTime = outDate - inDate;

    // Convert ms → days
    const nights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return nights;
}

const sanitizeToText = (html) => {
    const clean = sanitizeHtml(html, { allowedTags: [], allowedAttributes: {} });
    return clean;
};

function ItineryFinal() {


    const navigate = useNavigate();

    const { destinationId, custId, tourId } = useParams();
    console.log("custId from params: ", custId)
    console.log("tourId from params: ", tourId)
    const [itinerary, setItinerary] = useState([])
    const [packages, SetPackages] = useState({})
    const [tour, setTour] = useState({})
    const [hotelDetails, setHotelDetails] = useState([])
    const [transport, setTransport] = useState({})
    const [allTransport, setAllTransport] = useState([])
    const [computedPricing, setComputedPricing] = useState({})
    const [customer, setCustomer] = useState({})
    const [img, setImg] = useState(hotelImg)
    const [hotelPrice, setHotelPrice] = useState(0)
    const [transportPrice, setTransportPrice] = useState(0)
    const [rooms, setRooms] = useState([])
    //   const [finalImg, setFinalImg] = useState(hotelimg);
    const [loading, setLoading] = useState(true);
    useEffect(() => {


        // console.log("id from package overview: ", id)
        const fetchItinerary_wrt_id = async () => {
            try {
                const res = await api.get(`/destinations/${destinationId}/tours/${tourId}/itinerary/${custId}`);
                console.log("the response from package itinerary: ", res.data)



                if (res.data?.success === true) {

                    SetPackages(res?.data?.data?.package)
                    setItinerary(res?.data?.data?.itineraries)
                    setTour(res?.data?.data?.tour)
                    setComputedPricing(res?.data?.data?.computed_pricing)
                    setHotelDetails(res?.data?.data?.hotels)
                    setAllTransport(res?.data?.data?.transports);
                    setTransport(res?.data?.data?.transport_display);
                    setRooms(res?.data?.data?.rooms);
                    setCustomer(res?.data?.data?.customer);
                    setImg(res?.data?.data?.package?.featured_photo || hotelImg);
                    const hoteldata = res?.data?.data?.tour?.hotel_data_raw;
                    const transportdata = res?.data?.data?.tour?.transport_data_raw;

                    try {
                        setHotelPrice(hoteldata ? hoteldata : null);
                    } catch (e) {
                        console.error("Invalid hotel_data JSON:", hoteldata, e);
                        setHotelPrice(null);
                    }

                    try {
                        setTransportPrice(transportdata ? transportdata : null);
                    } catch (e) {
                        console.error("Invalid transport_data JSON:", transportdata, e);
                        setTransportPrice(null);
                    }




                }


            } catch (err) {
                console.log(err)
            } finally {
                setTimeout(() => setLoading(false), 4000);
            }
        }
        fetchItinerary_wrt_id();

    }, [custId, destinationId, tourId])
    // useEffect(() => {
    //   const imgUrl = packages?.featured_photo;

    //   if (!imgUrl) {
    //     setFinalImg(hotelimg);
    //     return;
    //   }

    //   // Try to load the remote image
    //   fetch(imgUrl, { method: "HEAD" }) // check if URL is reachable
    //     .then((res) => {
    //       console.log("res <<<<<>>>> : ",res);
    //       if (res.ok){
    //         setFinalImg(imgUrl);
    //         console.log("img url is fine")
    //       } 
    //       else {
    //         setFinalImg(hotelimg); // fallback
    //         console.log("img url is not fine")
    //       }
    //     })
    //     .catch(() => setFinalImg(hotelimg)); // fallback on error
    // }, [packages]);

    console.log("hotelPrice", hotelPrice)
    console.log("transportPrice", transportPrice)

    let totalAdult = 0;
    let totalChild = 0;
    let totalInfant = 0;

    if (hotelPrice && typeof hotelPrice === "object") {
        Object.values(hotelPrice).forEach(item => {
            totalAdult += Number(item.adult_price || 0);
            totalChild += Number(item.child_price || 0);
            totalInfant += Number(item.infant_price || 0);
        });
    }

    let groupedTotals = {};

    if (transportPrice && typeof transportPrice === "object") {
        Object.values(transportPrice).forEach(arr => {
            if (Array.isArray(arr)) {
                arr.forEach(item => {
                    const id = item.transport_id;
                    const base = Number(item.base_price || 0);
                    const extra = Number(item.extra_price || 0);

                    if (!groupedTotals[id]) {
                        groupedTotals[id] = { baseTotal: 0, extraTotal: 0, grandTotal: 0 };
                    }

                    groupedTotals[id].baseTotal += base;
                    groupedTotals[id].extraTotal += extra;
                    groupedTotals[id].grandTotal += base + extra;
                });
            }
        });
    }

    const totalTransportAmount = Object.values(groupedTotals).reduce(
        (sum, item) => sum + item.grandTotal,
        0
    );

    console.log("Total Transport Amount:", totalTransportAmount);
    const mealPlan = rooms.map(room => {
        const meals = [];
        if (room.breakfast) meals.push("Breakfast");
        if (room.lunch) meals.push("Lunch");
        if (room.dinner) meals.push("Dinner");

        return meals.length > 0 ? meals.join(" + ") : "";
    });


    return (
        <div className="itinerary-container">
            {/* Cover / Welcome */}
            <section className="itinerary-page">
                <span style={{ display: "flex", justifyContent: "center" }}><img src={logo} width="150px" height="150px" /></span>

                <p className="itinerary-welcome">
                    <span style={{ fontWeight: "500", fontSize: "1.3rem" }}>Namaste!</span>
                    <span>You're warmly welcomed to Jayraj Group, where we're dedicated
                        to making your spiritual journey to Kedarnath and Badrinath Dham truly
                        unforgettable. This sacred pilgrimage is a perfect blend of devotion,
                        spiritual growth, and breathtaking natural beauty, promising a
                        life-enriching experience.</span>

                </p>
                <div style={{ marginTop: "200px", maxWidth: "700px" }}>
                    <img src={pdfhomeimg} width="100%" />
                </div>

            </section>

            {/* Package Details */}
            <section className="itinerary-page">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <h2 className="itinerary-heading">Package Details</h2>
                    <img src={logo} alt="Jayraj Group Logo" className="itinerary-logo" />

                </div>

                <table className="itinerary-details">
                    <tbody>
                        <tr><td>Name</td><td>{customer?.name}</td></tr>
                        <tr><td>Tour ID</td><td>CP{tour?.id || "N/A"}</td></tr>
                        <tr><td>Phone No.</td><td>{customer?.mobile}</td></tr>
                        <tr><td>Whatsapp No.</td><td>{customer?.whatsapp_no}</td></tr>
                        <tr><td>Email ID</td><td>{customer?.email}</td></tr>
                        <tr><td>Address</td><td>{customer?.address}</td></tr>
                        <tr><td>Package</td><td>{tour?.trip_type_name}</td></tr>
                        <tr><td>Travel Dates</td><td>              {tour?.dates?.range?.start && tour?.dates?.range?.end
                            ? `${formatDate(tour.dates?.range?.start)} to ${formatDate(tour.dates?.range?.end)}`
                            : "Not Available"}</td></tr>
                        <tr>
                            <td>Meal Plan</td>
                            <td>
                                Breakfast/Lunch/Dinner
                            </td>
                        </tr>
                        <tr><td>Room Category</td><td>
                            {/* {hotelDetails
                                ?.flatMap((hotel) => hotel.rooms || []) 
                                .map((room, idx, arr) => (
                                    <span key={room.id}>
                                        {room.room_type}
                                        {idx < arr.length - 1 ? " / " : ""} 
                                    </span>
                                ))} */}
                            Standard/Semi Deluxe/Deluxe

                        </td></tr>
                        <tr><td>Duration</td><td> {tour?.no_of_days ? `${tour?.no_of_days} Days` : ""} {tour?.no_of_nights ? `${tour?.no_of_nights} Nights` : ""}</td></tr>
                        <tr>
                            <td>Guest Count</td>
                            <td>
                                {tour?.trip_type_id === 5 ? (
                                    <>
                                        {tour?.counts?.adult || 0} Adult{" "}
                                        {tour?.counts?.child || 0} Child{" "}
                                        {tour?.counts?.infant || 0} Infant
                                    </>
                                ) : (
                                    <>
                                        {computedPricing?.persons?.adult || 0} Adult{" "}
                                        {computedPricing?.persons?.child || 0} Child{" "}
                                        {computedPricing?.persons?.infant || 0} Infant
                                    </>
                                )}
                            </td>
                        </tr>

                    </tbody>
                </table>
                <span style={{ display: "flex", justifyContent: "center", marginTop: "160px" }}><img src={packageImgpdf} width="100%" height="100%" /></span>
            </section>

            {/* Tour Details */}
            <section className="itinerary-page">
                <div className="itinerary-destination-header">
                    <span className="itinerary-heading"><strong>Tour Details</strong></span>
                    <img
                        src={logo}
                        alt="Jayraj Group Logo"
                        className="itinerary-logo"
                    />
                </div>

                {/* Image */}
                <div className="itinerary-photo-wrapper">
                    <img
                        src={`${tour?.images?.find(img => img.is_featured)?.url ||img}`}
                        alt="Haridwar"
                        className="itinerary-photo"
                    />
                </div>

                {/* Overview Box */}
                <div className="itinerary-overview-box">
                    <p className="itinerary-overview-title">{tour?.title}:</p>
                    <p className="itinerary-overview-text">
                        {sanitizeToText(tour?.description || "")}
                    </p>



                </div>
            </section>

            {/* Brief Itinerary */}
            <section className="itinerary-page">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <h2 className="itinerary-heading">Breif Itinerary</h2>
                    <img src={logo} alt="Jayraj Group Logo" className="itinerary-logo" />
                </div>

                {itinerary?.map((item, index) => {
                    // Base date = tour_start_date from your API
                    const baseDate = new Date(tour?.tour_start_date);

                    // Add days according to index (Day 1 = +0, Day 2 = +1, etc.)
                    const currentDate = new Date(baseDate);
                    currentDate.setDate(baseDate.getDate() + index);

                    // ✅ Correct way to get today's transports
                    const todayTransports = transport?.[item.day] || [];


                    return (
                        <div key={index} className="itinerary-day-box">
                            <div className="itinerary-day-header">
                                <span className="itinerary-day-title">Day - {item?.day}</span>
                                {currentDate && !isNaN(new Date(currentDate)) ? formatDate(currentDate) : ""}
                            </div>

                            {/* Plans */}
                            <div className="itinerary-plan">
                                <p className="itinerary-place">{item?.name}</p>
                                <p className="itinerary-note" style={{ textAlign: "justify" }}>
                                    {sanitizeToText(item?.description || "")}
                                </p>
                            </div>

                            {/* ✅ Transports for this day */}
                            {todayTransports.length > 0 && (
                                <div className="itinerary-transport-box">
                                    <h4>Transport</h4>

                                    {todayTransports.map((t, tIndex) => (
                                        <div key={tIndex} className="itinerary-transport-card">
                                            <p><strong>{t.transport_name}</strong> ({t.ac_type})</p>
                                            <p>Capacity: {t.capacity}</p>
                                            <p>Base Price: ₹{t.base_price}</p>
                                            <p>Per KM Price: ₹{t.per_km}</p>
                                            <p>Extra Price: ₹{t.extra_price}</p>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}

            </section>







            {/* Destination Example */}
            <section className="itinerary-page">
                <div className="itinerary-destination-header">
                    <span className="itinerary-heading"><strong>Destination</strong>: {tour?.destination?.name}</span>
                    <img
                        src={logo}
                        alt="Jayraj Group Logo"
                        className="itinerary-logo"
                    />
                </div>

                {/* Image */}
                <div className="itinerary-photo-wrapper">
                    <img
                        src={`${tour?.destination?.featured_photo || img}`}
                        alt="Haridwar"
                        className="itinerary-photo"
                    />
                </div>

                {/* Overview Box */}
                <div className="itinerary-overview-box">
                    <p className="itinerary-overview-title">Overview:</p>
                    <p className="itinerary-overview-text">
                        {sanitizeToText(tour?.destination?.description || "")}
                    </p>
                                <div style={{ display: "flex", justifyContent: 'center' }}>
                                    <button
                                        className="itinerary-btn"
                                        onClick={()=>navigate("/destination-images",{state:{images:tour?.destination?.gallery_photos}})}
                                    >
                                        View more images
                                    </button>

                                </div>

                </div>
            </section>


            {/* hotel details */}

            <section className="itinerary-page">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <h2 className="itinerary-heading">Hotels</h2>
                    <img src={logo} alt="Jayraj Group Logo" className="itinerary-logo" />
                </div>

                {hotelDetails?.map((hotel, index) => (
                    <div key={index} className="pdf-hotel-card">
                        <div className="pdf-hotel-header">
                            <img
                                src={`https://admin.jayrajgroup.org/uploads/hotels/${hotel.featured_image}`}
                                alt={hotel.name}
                                className="pdf-hotel-image"
                            />
                            <div className="pdf-hotel-info">
                                <h3>{hotel.name}</h3>
                                <p className="pdf-hotel-location">{hotel.location}</p>
                                <p className="pdf-hotel-landmark">Landmark: {hotel.land_mark}</p>
                                <div className="pdf-hotel-description">
                                    {sanitizeToText(hotel.description || "")}
                                </div>

                            </div>
                        </div>

                        {/* Gallery */}
                        {hotel.gallery?.length > 0 && (
                            <div className="pdf-hotel-gallery">
                                {hotel.gallery.slice(0, 4).map((g, i) => (
                                    <img key={i} src={g} alt={`gallery-${i}`} />
                                ))}
                            </div>
                        )}

                        {/* Rooms */}
                        <div className="pdf-hotel-rooms">
                            <h4>Rooms</h4>
                            {hotel.rooms?.map((room, rIndex) => (
                                <div key={rIndex} className="pdf-hotel-room">
                                    <img
                                        src={room.featured_image}
                                        alt={room.name}
                                        className="pdf-room-image"
                                    />
                                    <div className="pdf-room-info">
                                        <h5>{room.name}</h5>
                                        <p>Type: {room.room_type}</p>
                                        <p>Max Guests: {room.max_guests}</p>
                                        <p>Fooding: {room.fooding}</p>
                                        <p>Price/Night: ₹{room.price_per_night}</p>
                                        <div>{sanitizeToText(room.description || "")}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </section>

            {/* Quotation */}
            <section className="itinerary-page">
                <div className="itinerary-destination-header">
                    <h2 className="itinerary-heading">Quotation</h2>
                    <img src={logo} alt="Jayraj Group Logo" className="itinerary-logo" />
                </div>

                {/* Quotation Box */}
                <div className="itinerary-quotation-box">
                    <div className="itinerary-quotation-row">
                        <span>No. of Paying Person</span>
                        <span>No. of Adult + No. of Child</span>
                    </div>
                    {tour?.trip_type_id === 5 ? (<div>
                                            <div className="itinerary-quotation-row">
                        <span>Per Person</span>
                        <span>₹ {tour?.pricing?.stored_totals?.total_price} /-</span>
                    </div>
                    <div className="itinerary-quotation-row">
                        <span style={{ fontSize: "1rem", fontWeight: "600" }}>Total Price</span>
                        <span style={{ fontSize: "1rem", fontWeight: "600" }}>₹ {(tour?.pricing?.stored_totals?.total_price)*((tour?.counts?.adult+ tour?.counts?.child) || (computedPricing?.persons?.adult + computedPricing?.persons?.child))} /-</span>
                    </div>
                    </div>):
                    <div>
                    <span style={{ fontSize: "1.2rem", fontWeight: "700" }}>Basic</span>
                    <div className="itinerary-quotation-row">
                        <span>Per Person</span>
                        <span>₹ {computedPricing?.per_person?.basic} /-</span>
                    </div>
                    <div className="itinerary-quotation-row">
                        <span>Total Price</span>
                        <span>₹ {computedPricing?.totals?.basic} /-</span>
                    </div>
                    <span style={{ fontSize: "1.2rem", fontWeight: "700" }}>Standard</span>
                    <div className="itinerary-quotation-row">
                        <span>Per Person</span>
                        <span>₹ {computedPricing?.per_person?.standard} /-</span>
                    </div>
                    <div className="itinerary-quotation-row">
                        <span>Total Price</span>
                        <span>₹ {computedPricing?.totals?.standard} /-</span>
                    </div>
                    <span style={{ fontSize: "1.2rem", fontWeight: "700" }}>Premium</span>
                    <div className="itinerary-quotation-row">
                        <span>Per Person</span>
                        <span>₹ {computedPricing?.per_person?.premium} /-</span>
                    </div>
                    <div className="itinerary-quotation-row">
                        <span>Total Price</span>
                        <span>₹ {computedPricing?.totals?.premium} /-</span>
                    </div>
                    </div>
                    }
                </div>
                {/* <div className="itinerary-quotation-row">
                        <span>Itinerary</span>
                        <span>- Rs _____/-</span>
                    </div>
                    <div className="itinerary-quotation-row">
                        <span>No. of Adult</span>
                        <span>{tour?.adult_count}</span>
                    </div> */}

                {/* <hr className="itinerary-divider" />

                    <div className="itinerary-quotation-row total">
                        <span>Total Price</span>
                        <span>- Rs {tour?.pricing?.stored_totals?.total_price} /-</span>
                    </div>
                </div> */}

                {/* Vehicle Table */}
                {/* <section className="itinerary-quotation-box">
                    {/* <h3 className="itinerary-subheading">Vehicle</h3>
                    <table className="itinerary-details">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Capacity</th>
                                <th>Pickup/Drop</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{transport?.type}({transport?.ac_type})</td>
                                <td>{transport?.capacity}</td>

                                <td>{transport?.points?.map((point) => {
                                    if (point?.type === "boarding")
                                        return `${point?.location}/`
                                    else {
                                        return `${point?.location}`
                                    }
                                }
                                )}</td>
                            </tr>
                        </tbody>
                    </table> */}
                {/* Button */}
                {/* <div style={{ display: "flex", justifyContent: 'center' }}>
                        <button className="itinerary-btn">Add Pilgrim Details</button>
                    </div> */}


                {/* </section> */}


                {/* Illustration */}

                <span style={{ display: "flex", justifyContent: "center", marginTop: "170px" }}><img src={vahicle} width="100%" height="100%" /></span>


            </section>


            {/* Booking Process */}
            {/* <section className="itinerary-page">
                <h2 className="itinerary-heading">Booking Process</h2>
                <ul className="itinerary-list">
                    <li><strong>Advance Payment:</strong> Deposit 30% advance</li>
                    <li><strong>Balance Payment:</strong> Pay at Hotel Vivek Guptkashi</li>
                    <li><strong>Important:</strong> Only follow mentioned payment methods</li>
                </ul>
            </section> */}

            {/* Preparation */}
            {/* <section className="itinerary-page">
                <h2 className="itinerary-heading">Preparation is Key</h2>
                <ul className="itinerary-list">
                    <li>Carry warm clothes, sturdy shoes, raincoat</li>
                    <li>Bring ID cards & Yatra registration</li>
                    <li>Stay hydrated on treks</li>
                    <li>Dispose waste properly & respect local customs</li>
                </ul>
            </section> */}

            {/* Terms */}
            {/* <section className="itinerary-page">
                <h2 className="itinerary-heading">Terms & Conditions</h2>
                <ul className="itinerary-list">
                    <li>30% advance; remaining 70% at Hotel Vivek</li>
                    <li>Cancellation: full refund before 30 days; none within 30 days</li>
                    <li>No alcohol during the trip</li>
                    <li>Personal expenses to be borne by pilgrims</li>
                </ul>
            </section> */}

            {/* Footer */}
            <section className="itinerary-page itinerary-footer">
                {/* Logo */}
                <div className="footer-logo">
                    <img src={logo} alt="Jayraj Group Logo" />
                    <h3>JAYRAJ GROUP</h3>
                </div>

                {/* Contact Info */}
                <div className="footer-contacts">
                    <div>
                        <p>+91-8869872377</p>
                        <p>+91-8954446577</p>
                    </div>
                    <div>
                        <p>info@jayrajgroup.org</p>
                        <p>www.jayrajgroup.org</p>
                    </div>
                </div>

                {/* Social Icons */}
                <div className="footer-social">
                    <p>Visit Us</p>
                    <div className="footer-icons">

                        <FaWhatsapp />
                        <FaYoutube />
                        <FaInstagram />
                        <FaFacebook />
                    </div>
                </div>

                {/* Office Info */}
                <div className="footer-office">
                    <p>
                        <strong>Corporate Office</strong><br />
                        Semi Talli Ukhimath Kedarnath Road, Rudraprayag Kedarnath, Uttarakhand-246439, India.
                    </p>
                    <p>
                        GST : 05BFVPJ3757G1Z2 &nbsp;&nbsp; | &nbsp;&nbsp; UDYAM : UDYAM-UK-10-0004280
                    </p>
                </div>
            </section>


            {/* Print Button */}
            <button onClick={() => window.print()} className="itinerary-print-btn">
                Print Itinerary
            </button>
        </div>
    )
}

export default ItineryFinal